__webpack_require__.p = "/product-updates-global-state/system-email-templates/";